import {
  fetchCurrentUser,
  fetchCustomClientDetails,
  fetchDocTypesAvailable,
  fetchToolsAvailable,
  fetchUploadDocTypes,
} from '@services/user';
import { fetchStaticCopy } from '@services/application';
import { fetchMacroDocs } from '@services/docs';
import { fetchWatchlist } from '@hooks/features/useWatchlist';
import { fetchClientDocs } from '@hooks/features/useClientData';
import { loadGptModels } from '@services/gptModels';
import * as Sentry from '@sentry/react';

export const getRequiredData = async (dispatch) => {
  await loadGptModels()(dispatch);

  const requests = [
    fetchCustomClientDetails()(dispatch),
    fetchCurrentUser()(dispatch),
    fetchStaticCopy()(dispatch),
    fetchToolsAvailable()(dispatch),
    fetchUploadDocTypes()(dispatch),
    fetchWatchlist(dispatch),
    fetchClientDocs(dispatch),
  ];
  return Promise.all(requests);
};

export const getDataForCache = async (dispatch) => {
  const requests = [fetchDocTypesAvailable()(dispatch), fetchMacroDocs()(dispatch)];
  return Promise.all(requests);
};

export const handleAppTrackingInit = async (currentUserResponse) => {
  if (currentUserResponse?.status === 200) {
    const { data: user } = currentUserResponse;
    Sentry.setUser({
      id: user.id,
      is_tornado_employee: user.is_nvstr_employee,
    });

    return null;
  }
};
